import React from 'react';
import { NEW_PATIENTS_REPORT_PER_PAGE } from 'infrastructure/hooks/rpm/newPatientsReport/use-get-new-patients-report';

import s from './styles.module.scss';

interface IProps {
  currentPage: number;
  idx: number;
}

const NumberColumn: React.FC<IProps> = ({ currentPage, idx }) => {
  const itemIndexPrefix = (currentPage - 1) * NEW_PATIENTS_REPORT_PER_PAGE;

  return <span className={s['item-number']}>{itemIndexPrefix + idx + 1}</span>;
};

export default NumberColumn;
